/**
 * Optimizer Control Center — 1-second clock tick for live countdowns
 * For Media Devoted | Created By Ciro Autiero
 */

import { useEffect, useState } from 'react';

/** Re-renders every second with the current epoch ms (à la ScheduledFetchPanel). */
export function useCountdownTick(enabled = true): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    const id = window.setInterval(() => setNowMs(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [enabled]);

  return nowMs;
}
